import React from 'react';
import { getSortButton } from '../../utilities/sortUtility';
import { DragSourceAndDropTarget, DragAndDropSpace } from '../DnDWrapper';
import _ from 'lodash';
import { isApiFlagOn } from '../../utilities/commonUtil';

export const PartnerCompaniesOrderContents = ({
  partnerCompanies,
  nestCount,
  callbacks,
  canDrag,
  columnSortOrder,
}) => {
  const partnerCompany = [];
  _.map(partnerCompanies, (value, key) => {
    if (partnerCompanies[key]['private_partner_company_flag'] === 0) {
      partnerCompany.push(value);
    }
  });

  const PartnerCompanyDndSpace = element => {
    return <DragAndDropSpace>{element}</DragAndDropSpace>;
  };

  return PartnerCompanyDndSpace(
    <div className='setting-main__table'>
      <table className='setting-table'>
        <thead className='setting-table__header'>
          <tr className='setting-table__label'>
            <td className='value-table gate-list-value-table__drag'>
              <div className='value-table__label' />
            </td>
            <td className='value-table gate-list-value-table__size sys-sort-toggle'>
              <div className='value-table__label'>協力会社名</div>
            </td>
            <td className='value-table gate-list-value-table__date sys-sort-toggle'>
              <div
                className='value-table__label'
                onClick={() =>
                  callbacks.columnSort.onClickColumnTitle(
                    'partnerCompanyNameKana'
                  )
                }
              >
                ふりがな
                {getSortButton(columnSortOrder, 'partnerCompanyNameKana')}
              </div>
            </td>
            <td className='value-table gate-list-value-table__date sys-sort-toggle'>
              <div className='value-table__label'>職種</div>
            </td>
            <td className='value-table gate-list-value-table__date sys-sort-toggle'>
              <div className='value-table__label'>ステータス</div>
            </td>
            <td className='value-table gate-list-value-table__menu sys-sort-toggle'>
              <div className='value-table__label' />
            </td>
          </tr>
        </thead>
        <tbody>
          {partnerCompany.map((partner, index) => (
            <PartnerCompany
              key={index}
              id={partner.id}
              company_name={partner.company_name}
              company_kana={partner.company_kana}
              job={partner.job}
              has_children={partner.has_children}
              finish_flag={partner.finish_flag}
              nestCount={nestCount}
              onHover={callbacks.dnd.onHover}
              onBeginDrag={callbacks.dnd.onBeginDrag}
              onDropped={callbacks.dnd.onDropped}
              setFieldTreeId={callbacks.table.setFieldTreeId}
              canDrag={canDrag}
            />
          ))}
        </tbody>
      </table>
      {}
    </div>
  );
};

export const PrivatePartnerCompaniesOrderContents = ({
  partnerCompanies,
  nestCount,
  callbacks,
  canDrag,
}) => {
  const privatePartnerCompany = [];
  _.map(partnerCompanies, (value, key) => {
    if (partnerCompanies[key]['private_partner_company_flag'] === 1) {
      privatePartnerCompany.push(value);
    }
  });

  const PrivatePartnerCompanyDndSpace = elements => {
    return <DragAndDropSpace>{elements}</DragAndDropSpace>;
  };

  //別途業者
  return PrivatePartnerCompanyDndSpace(
    <table className='setting-table margin-top__20'>
      <thead className='setting-table__header'>
        <tr className='setting-table__label'>
          <td className='value-table gate-list-value-table__drag'>
            <div className='value-table__label' />
          </td>
          <td className='value-table gate-list-value-table__drag'>
            <div className='value-table__label' />
          </td>
          <td className='value-table gate-list-value-table__size sys-sort-toggle'>
            <div className='value-table__label'>以下 別途業者</div>
          </td>
          <td className='value-table gate-list-value-table__drag'>
            <div className='value-table__label' />
          </td>
          <td className='value-table gate-list-value-table__drag'>
            <div className='value-table__label'>ステータス</div>
          </td>
          <td className='value-table gate-list-value-table__menu sys-sort-toggle'>
            <div className='value-table__label' />
          </td>
        </tr>
      </thead>
      <tbody>
        {privatePartnerCompany.map((privatePartner, index) => (
          <PrivatePartnerCompany
            key={index}
            id={privatePartner.id}
            company_name={privatePartner.company_name}
            company_kana={privatePartner.company_kana}
            job={privatePartner.job}
            has_children={privatePartner.has_children}
            finish_flag={privatePartner.finish_flag}
            nestCount={nestCount}
            onHover={callbacks.dnd.onHover}
            onBeginDrag={callbacks.dnd.onBeginDrag}
            onDropped={callbacks.dnd.onDropped}
            setFieldTreeId={callbacks.table.setFieldTreeId}
            canDrag={canDrag}
          />
        ))}
      </tbody>
    </table>
  );
};

export class PartnerCompany extends React.PureComponent {
  render() {
    const {
      company_name,
      company_kana,
      job,
      has_children,
      finish_flag,
      nestCount,
      canDrag,
      id,
      onHover,
      onBeginDrag,
      onDropped,
      setFieldTreeId,
    } = this.props;

    if (!canDrag) {
      return (
        <tr id={`gate-${id}`} className='setting-table__item'>
          <td className='gate-list-value-table__drag'>
            <button className='btn-icon--sm'>
              <i className='i-drag i-3x' />
            </button>
          </td>
          <td className='gate-list-value-table__value--name'>{company_name}</td>
          <td className='gate-list-value-table__value--name'>{company_kana}</td>
          <td className='gate-list-value-table__value--name'>{job}</td>
          <td className='gate-list-value-table__value--name'>
            {renderFinishStatus(finish_flag)}
          </td>
          <td className='gate-list-value-table__value--menu'>
            <ul className='setting-edit-menu'>
              <li className='setting-edit-menu__item'>
                {has_children ? (
                  <button
                    className='btn--sm--stay'
                    onClick={() => setFieldTreeId(id)}
                  >
                    {nestCount + 2}次協力会社並び順
                  </button>
                ) : null}
              </li>
            </ul>
          </td>
        </tr>
      );
    }

    return (
      <DragSourceAndDropTarget
        id={`partnerCompanyDnD`}
        index={id}
        // data={partnerCompany}
        onHover={onHover}
        onBeginDrag={onBeginDrag}
        onDropped={onDropped}
        canDrag={true}
        canDrop={true}
      >
        <tr id={`gate-${id}`} className='setting-table__item'>
          <td className='gate-list-value-table__drag'>
            <button className='btn-icon--sm'>
              <i className='i-drag i-3x' />
            </button>
          </td>
          <td className='gate-list-value-table__value--name'>{company_name}</td>
          <td className='gate-list-value-table__value--name'>{company_kana}</td>
          <td className='gate-list-value-table__value--name'>{job}</td>
          <td className='gate-list-value-table__value--name'>
            {renderFinishStatus(finish_flag)}
          </td>
          <td className='gate-list-value-table__value--menu'>
            <ul className='setting-edit-menu'>
              <li className='setting-edit-menu__item'>
                {has_children ? (
                  <button
                    className='btn--sm--stay'
                    onClick={() => setFieldTreeId(id)}
                  >
                    {nestCount + 2}次協力会社並び順
                  </button>
                ) : null}
              </li>
            </ul>
          </td>
        </tr>
      </DragSourceAndDropTarget>
    );
  }
}

export class PrivatePartnerCompany extends React.PureComponent {
  render() {
    const {
      company_name,
      company_kana,
      job,
      has_children,
      finish_flag,
      nestCount,
      canDrag,
      id,
      onHover,
      onBeginDrag,
      onDropped,
      setFieldTreeId,
    } = this.props;

    if (!canDrag) {
      return (
        <tr id={`gate-${id}`} className='setting-table__item'>
          <td className='gate-list-value-table__drag'>
            <button className='btn-icon--sm'>
              <i className='i-drag i-3x' />
            </button>
          </td>
          <td className='gate-list-value-table__value--name'>{company_name}</td>
          <td className='gate-list-value-table__value--name'>{company_kana}</td>
          <td className='gate-list-value-table__value--name'>{job}</td>
          <td className='gate-list-value-table__value--name'>
            {renderFinishStatus(finish_flag)}
          </td>
          <td className='gate-list-value-table__value--menu'>
            <ul className='setting-edit-menu'>
              <li className='setting-edit-menu__item'>
                {has_children ? (
                  <button
                    className='btn--sm--stay'
                    onClick={() => setFieldTreeId(id)}
                  >
                    {nestCount + 2}次協力会社並び順
                  </button>
                ) : null}
              </li>
            </ul>
          </td>
        </tr>
      );
    }

    return (
      <DragSourceAndDropTarget
        id={`partnerCompanyDnD`}
        index={id}
        // data={partnerCompany}
        onHover={onHover}
        onBeginDrag={onBeginDrag}
        onDropped={onDropped}
        canDrag={true}
        canDrop={true}
      >
        <tr id={`gate-${id}`} className='setting-table__item'>
          <td className='gate-list-value-table__drag'>
            <button className='btn-icon--sm'>
              <i className='i-drag i-3x' />
            </button>
          </td>
          <td className='gate-list-value-table__value--name'>{company_name}</td>
          <td className='gate-list-value-table__value--name'>{company_kana}</td>
          <td className='gate-list-value-table__value--name'>{job}</td>
          <td className='gate-list-value-table__value--name'>
            {renderFinishStatus(finish_flag)}
          </td>
          <td className='gate-list-value-table__value--menu'>
            <ul className='setting-edit-menu'>
              <li className='setting-edit-menu__item'>
                {has_children ? (
                  <button
                    className='btn--sm--stay'
                    onClick={() => setFieldTreeId(id)}
                  >
                    {nestCount + 2}次協力会社並び順
                  </button>
                ) : null}
              </li>
            </ul>
          </td>
        </tr>
      </DragSourceAndDropTarget>
    );
  }
}

/**
 * render text for column Status(ステータス) base on finish_flag of Partner company
 * @param {number|string} finish_flag finish work status of Partner company
 * @return {string} '作業終了': finished Partner(finish_flag == 1); ''(empty): active Partner(finish_flag == 0)
 */
const renderFinishStatus = finish_flag => {
  return isApiFlagOn(finish_flag) ? '作業終了' : '';
};



// WEBPACK FOOTER //
// ./src/components/tables/PartnerCompaniesOrder.jsx